<ui-banner variant="warning" class="margin-top-1 margin-bottom-2">
    <p>{{ 'forms.change-requests.requestVisibilityNotice' | translate }}</p>
</ui-banner>

<div class="app-grid">
    <ui-card class="columns-8">
        <form autocomplete="off" #form="ngForm">
            <h4 id="request-submitter-header">{{ 'forms.change-requests.requestSubmitter' | translate }}</h4>
            <div class="app-grid">
                <span class="margin-bottom-2 columns-12"
                    >{{ 'forms.change-requests.requestFieldValueVisibilityNotice' | translate }}
                </span>
                <mat-form-field class="margin-top-1 no-labels columns-6 large-columns-10 medium-columns-12">
                    <mat-select
                        aria-labelledby="request-submitter-header"
                        multiple
                        [(ngModel)]="selectedRoleIds"
                        (selectionChange)="onSelectionChange($event)"
                        name="roles"
                    >
                        <mat-select-trigger>
                            @for (name of selectedRoleNames; track $index) {
                                @if ($index > 0) {
                                    <span>,&nbsp;</span>
                                }
                                <span>{{ name | translate }}</span>
                            }
                        </mat-select-trigger>
                        <mat-option *ngFor="let role of this.roles" [value]="role.id" [disabled]="isDefaultAdmin(role)">
                            <div class="option-body">
                                <span>{{ role.name | appTranslateOptions: roleNameDisplay }}</span>
                                <span class="sub-label">{{
                                    'forms.change-requests.accessLevel.canRequestFor'
                                        | translate: { permission: (getRoleAccessLevelDescription(role) | translate) }
                                }}</span>
                            </div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
    </ui-card>

    <ui-card class="columns-8">
        <h4 id="request-approver-header">{{ 'forms.change-requests.requestApprover' | translate }}</h4>
        <p>{{ 'forms.change-requests.selectApproverNotificationInstruction' | translate }}</p>
        <approval-workflow-config-panel
            [aria-labelledby]="'request-approver-header'"
            [workflow]="approvalWorkflow"
        ></approval-workflow-config-panel>
    </ui-card>

    <ui-card class="columns-8">
        <h4>{{ 'forms.change-requests.requestNotifiable' | translate }}</h4>
        <span>{{ 'forms.change-requests.requestSubjectDirectManagerNotifiedInstruction' | translate }}</span>
        <mat-checkbox [(ngModel)]="notifySubject" (change)="onNotifySubjectChange($event)" class="margin-top-2">
            <span>{{ 'forms.change-requests.requestSubjectNotifiedInstruction' | translate }}</span>
        </mat-checkbox>
    </ui-card>
</div>
